import { render } from "./monthNavigator.vue?vue&type=template&id=6d51355f&ts=true"
import script from "./monthNavigator.vue?vue&type=script&lang=ts"
export * from "./monthNavigator.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__